import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../context/AppContext';
import Navbar from '../components/Navbar';
import ProductCard from '../components/ProductCard';
import Footer from '../components/Footer';

/* ─────────── static data ─────────── */
const TRUST = [
  { icon: '🌿', label: '100% Natural'     },
  { icon: '🚫', label: 'No Preservatives' },
  { icon: '⚡', label: 'Zero Added Sugar' },
  { icon: '🚚', label: '2-Hour Delivery'  },
  { icon: '✅', label: 'FSSAI Certified'  },
  { icon: '☀️', label: 'Made Fresh Daily' },
];

const HOW = [
  { n:'01', icon:'🛒', title:'Browse',  desc:'57+ fresh items across juices, salads, sandwiches and smoothies.' },
  { n:'02', icon:'📝', title:'Order',   desc:'Quick checkout in under 30 seconds. Pay online or cash on delivery.' },
  { n:'03', icon:'👨‍🍳', title:'Prepare', desc:'Your order is freshly prepared right after placing — never pre-made.' },
  { n:'04', icon:'🚴', title:'Deliver', desc:'Delivered to your door within 2 hours, fresh and chilled.' },
];

const WHY = [
  { icon:'🌿', title:'100% Natural Ingredients',    desc:'We source fresh, seasonal produce from local farms daily. No artificial flavors, colors, or additives — ever.',      color:'#2D8B4E' },
  { icon:'🚫', title:'Absolutely No Preservatives', desc:'Everything is made fresh each morning. We don\'t use shelf-life tricks — what you get is what nature intended.',     color:'#16a34a' },
  { icon:'⚡', title:'Zero Added Sugar',             desc:'Our drinks are sweetened only by nature. No refined sugars, no artificial sweeteners — just pure fruit goodness.',   color:'#d97706' },
  { icon:'🚚', title:'Delivered in 2 Hours',         desc:'Fresh from our kitchen to your doorstep in under 2 hours. Currently serving Hebbal, Bengaluru.',              color:'#2196F3' },
  { icon:'✅', title:'FSSAI Certified',               desc:'Our kitchen meets every food safety standard. FSSAI certified so you can order with complete confidence.',           color:'#9C27B0' },
  { icon:'☀️', title:'Sunrise Fresh Every Day',      desc:'Our team starts prepping at 5 AM every single day so your breakfast delivery is always at its freshest peak.',       color:'#FF6B35' },
];

const TESTIMONIALS = [
  { name:'Priya Sharma',  location:'Indiranagar',  rating:5, text:'The Green Detox juice has become my morning ritual. The freshness is unmatched — I can literally taste the difference from supermarket juices. Delivery is always on time!', avatar:'PS', orders:'34 orders' },
  { name:'Rahul Mehta',   location:'Koramangala',  rating:5, text:'I was skeptical at first but the Mixed Berry Blast converted me. No added sugar yet it tastes amazing. My whole office is now hooked on ProteinSpot smoothies!',             avatar:'RM', orders:'21 orders' },
  { name:'Anjali Kumar',  location:'Whitefield',   rating:5, text:'As a nutritionist I\'m very picky about what I recommend. ProteinSpot\'s ingredient transparency and zero-preservative promise make it the only fresh juice brand I trust.',  avatar:'AK', orders:'58 orders' },
  { name:'Vikram Nair',   location:'HSR Layout',   rating:5, text:'The protein smoothies are my post-gym go-to. Quick delivery and the quality is consistently excellent. Love that they tell you exactly what\'s in each bottle.',             avatar:'VN', orders:'17 orders' },
  { name:'Sneha Reddy',   location:'JP Nagar',     rating:5, text:'Ordered the Quinoa Power Bowl for the first time and now I can\'t imagine my lunch without it. Fresh, filling, and actually healthy unlike restaurant salads.',             avatar:'SR', orders:'29 orders' },
  { name:'Arjun Pillai',  location:'Marathahalli', rating:5, text:'Been ordering for 6 months. Never a bad experience. The seasonal specials are what keep me coming back — you can really tell they use the freshest produce that week.',       avatar:'AP', orders:'42 orders' },
];

const STATS = [
  { value:'500+', label:'Happy Customers',     icon:'👥' },
  { value:'57+',  label:'Fresh Products',      icon:'🥤' },
  { value:'4.9★', label:'Average Rating',      icon:'⭐' },
  { value:'2 hrs',label:'Delivery Time',       icon:'🚚' },
  { value:'0',    label:'Preservatives Used',  icon:'🚫' },
  { value:'365',  label:'Days Fresh Per Year', icon:'☀️' },
];

const SLIDES = [
  { key:'juices',      label:'Fresh Juices',       pet:'Cold- · 17 varieties',  sub:' daily from seasonal fruits — zero sugar, zero preservatives, all flavour.',                    image:'https://images.unsplash.com/photo-1622597467836-f3285f2131b8?w=1400&q=80&auto=format&fit=crop', color:'#2D8B4E', nav:'/products?section=juices'      },
  { key:'salads',      label:'Fresh Salads',        pet:'Farm-to-Table · 6 varieties',  sub:'Crisp greens, vibrant toppings and house dressings — light, filling and genuinely fresh.',             image:'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1400&q=80&auto=format&fit=crop', color:'#16a34a', nav:'/products?section=salads'      },
  { key:'sandwiches',  label:'Grilled Sandwiches',  pet:'Grilled Fresh · 17 varieties', sub:'Whole-grain bread loaded with fresh fillings, grilled to order — a proper meal every time.',           image:'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=1400&q=80&auto=format&fit=crop', color:'#d97706', nav:'/products?section=sandwiches'  },
  { key:'smoothies',   label:'Protein Smoothies',   pet:'Protein-Rich · 18 varieties',  sub:'Real fruit, seeds and superfoods blended thick — the cleanest fuel for your day.',                     image:'https://images.unsplash.com/photo-1553530666-ba11a90bb5ae?w=1400&q=80&auto=format&fit=crop', color:'#7c3aed', nav:'/products?section=smoothies'   },
  { key:'bestsellers', label:'Bestsellers',          pet:'Most Loved · Top picks',        sub:'Our most reordered items — customer favourites that never disappoint.',                                 image:'https://images.unsplash.com/photo-1464305795204-6f5bbfc7fb81?w=1400&q=80&auto=format&fit=crop', color:'#ea580c', nav:'/products?bestseller=true'     },
];

const SEC_COLORS = {
  juices:     { color:'#2D8B4E', bg:'rgba(45,139,78,0.08)',   accent:'#4CAF72'  },
  salads:     { color:'#16a34a', bg:'rgba(22,163,74,0.08)',   accent:'#22c55e'  },
  sandwiches: { color:'#d97706', bg:'rgba(217,119,6,0.08)',   accent:'#f59e0b'  },
  smoothies:  { color:'#7c3aed', bg:'rgba(124,58,237,0.08)',  accent:'#a78bfa'  },
};
const secStyle = k => SEC_COLORS[k] || { color:'#6b7280', bg:'rgba(107,114,128,0.08)', accent:'#9ca3af' };

/* ─────────── layout atoms ─────────── */
/* Every section uses W (max-width wrapper) for consistent horizontal padding */
const W = ({ children, style = {} }) => (
  <div style={{ maxWidth:1152, margin:'0 auto', padding:'0 20px', boxSizing:'border-box', width:'100%', ...style }}>
    {children}
  </div>
);

const Tag = ({ children, color = '#2D8B4E' }) => (
  <span style={{ display:'inline-block', fontSize:11, fontWeight:700, letterSpacing:'1.5px', textTransform:'uppercase', color, background:`${color}18`, border:`1px solid ${color}30`, padding:'3px 12px', borderRadius:100, marginBottom:10 }}>
    {children}
  </span>
);

const SectionHead = ({ tag, title, sub, align = 'center', tagColor }) => (
  <div style={{ textAlign:align, marginBottom:36 }}>
    {tag && <Tag color={tagColor}>{tag}</Tag>}
    <h2 style={{ fontSize:'clamp(22px,3.2vw,32px)', fontWeight:900, color:'#0f172a', margin:'0 0 10px', letterSpacing:'-0.5px', lineHeight:1.2 }}>{title}</h2>
    {sub && <p style={{ fontSize:15, color:'#6b7280', maxWidth:540, margin:align==='center'?'0 auto':0, lineHeight:1.7 }}>{sub}</p>}
  </div>
);

const Skeleton = ({ h = 280, cols = 4 }) => (
  <div style={{ display:'grid', gridTemplateColumns:`repeat(${cols},1fr)`, gap:16 }}>
    {Array.from({ length:cols }).map((_,i) => (
      <div key={i} style={{ height:h, borderRadius:18, background:'#f0f0f0', animation:'pulse 1.4s ease infinite' }} />
    ))}
  </div>
);

export default function HomePage() {
  const navigate = useNavigate();
  const [bestsellers,  setBestsellers]  = useState([]);
  const [featured,     setFeatured]     = useState([]);
  const [sections,     setSections]     = useState([]);
  const [loadingProds, setLoadingProds] = useState(true);
  const [activeReview, setActiveReview] = useState(0);
  const [slideIdx,     setSlideIdx]     = useState(0);
  const slideTimer  = useRef(null);
  const reviewTimer = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        const [bRes, fRes, sRes] = await Promise.all([
          api.get('/products?bestseller=true'),
          api.get('/products?featured=true'),
          api.get('/products/sections'),
        ]);
        setBestsellers((Array.isArray(bRes.data) ? bRes.data : bRes.data.products || []).slice(0,8));
        setFeatured(   (Array.isArray(fRes.data) ? fRes.data : fRes.data.products || []).slice(0,4));
        setSections(sRes.data?.sections || []);
      } catch {}
      finally { setLoadingProds(false); }
    })();
  }, []);

  useEffect(() => {
    slideTimer.current  = setInterval(() => setSlideIdx(p => (p+1) % SLIDES.length), 5000);
    reviewTimer.current = setInterval(() => setActiveReview(p => (p+1) % TESTIMONIALS.length), 5000);
    return () => { clearInterval(slideTimer.current); clearInterval(reviewTimer.current); };
  }, []);

  const goSlide = n => {
    setSlideIdx((n + SLIDES.length) % SLIDES.length);
    clearInterval(slideTimer.current);
    slideTimer.current = setInterval(() => setSlideIdx(p => (p+1) % SLIDES.length), 5000);
  };

  return (
    <div style={{ minHeight:'100vh', fontFamily:"'Roboto',sans-serif", background:'#f8fafb', overflowX:'hidden' }}>
      <Navbar />

      {/* ══ 1. HERO ══ */}
      <div style={{ background:'linear-gradient(135deg,#062c1b 0%,#0a3d1f 40%,#0f5230 70%,#1a7040 100%)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:-120, right:-120, width:500, height:500, borderRadius:'50%', background:'rgba(76,175,114,0.07)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:-80, left:-80, width:360, height:360, borderRadius:'50%', background:'rgba(255,179,71,0.05)', pointerEvents:'none' }} />
        <W style={{ paddingTop:52, paddingBottom:36 }}>
          <div className="hp-hero">
            {/* left */}
            <div>
              <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.2)', borderRadius:100, padding:'6px 16px', marginBottom:16, backdropFilter:'blur(8px)' }}>
                <span style={{ width:7, height:7, borderRadius:'50%', background:'#4ade80', animation:'blink 2s ease infinite', display:'inline-block' }} />
                <span style={{ color:'rgba(255,255,255,0.9)', fontSize:12, fontWeight:600 }}>Now serving Hebbal, Bengaluru · 2-hour delivery</span>
              </div>
              <h1 style={{ color:'#fff', fontWeight:900, fontSize:'clamp(28px,4.5vw,52px)', lineHeight:1.1, margin:'0 0 16px', letterSpacing:'-1px' }}>
                Fresh .<br />
                <span style={{ color:'#fbbf24' }}>Nature Pure.</span><br />
                Delivered Fast.
              </h1>
              <p style={{ color:'rgba(255,255,255,0.72)', fontSize:16, lineHeight:1.75, maxWidth:460, margin:'0 0 24px' }}>
                Cold- juices, salads, sandwiches and smoothies — made fresh every morning, zero preservatives, delivered in 2 hours.
              </p>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:28 }}>
                <button onClick={() => navigate('/products')} className="hp-btn-primary">Order Now →</button>
                <button onClick={() => navigate('/products')} className="hp-btn-ghost">Explore Menu</button>
              </div>
              <div className="hp-stats-row">
                {[['500+','Customers'],['57+','Products'],['4.9★','Rating'],['Free','on ₹299+']].map(([v,l]) => (
                  <div key={l}>
                    <div style={{ fontSize:20, fontWeight:900, color:'#fbbf24', letterSpacing:'-0.5px' }}>{v}</div>
                    <div style={{ fontSize:10, color:'rgba(255,255,255,0.5)', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* right */}
            <div className="hp-hero-right">
              {[
                { emoji:'🥤', label:'Cold- Juices',  sub:'17 varieties', bg:'rgba(45,139,78,0.28)',  nav:'/products?section=juices'      },
                { emoji:'🥗', label:'Fresh Salads',          sub:'6 varieties',  bg:'rgba(22,163,74,0.28)',  nav:'/products?section=salads'      },
                { emoji:'🥪', label:'Grilled Sandwiches',    sub:'17 varieties', bg:'rgba(217,119,6,0.28)',  nav:'/products?section=sandwiches'  },
                { emoji:'🍓', label:'Protein Smoothies',     sub:'18 varieties', bg:'rgba(124,58,237,0.28)', nav:'/products?section=smoothies'   },
              ].map(c => (
                <div key={c.label} onClick={() => navigate(c.nav)}
                  style={{ background:c.bg, border:'1px solid rgba(255,255,255,0.12)', borderRadius:18, padding:'22px 14px', textAlign:'center', cursor:'pointer', transition:'transform 0.2s, background 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.transform='scale(1.04)'; e.currentTarget.style.background=c.bg.replace('0.28','0.42'); }}
                  onMouseLeave={e => { e.currentTarget.style.transform='none';        e.currentTarget.style.background=c.bg; }}>
                  <div style={{ fontSize:30, marginBottom:8 }}>{c.emoji}</div>
                  <div style={{ fontSize:13, fontWeight:800, color:'#fff', marginBottom:3, lineHeight:1.2 }}>{c.label}</div>
                  <div style={{ fontSize:11, color:'rgba(255,255,255,0.6)', fontWeight:600 }}>{c.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </W>
      </div>

      {/* ══ 2. TRUST STRIP ══ */}
      <div style={{ background:'#fff', borderBottom:'1px solid #f0f0f0', boxShadow:'0 2px 12px rgba(0,0,0,0.04)' }}>
        <W>
          <div style={{ display:'flex', overflowX:'auto', scrollbarWidth:'none' }}>
            {TRUST.map((t,i) => (
              <div key={t.label} style={{ flex:'1 0 auto', display:'flex', alignItems:'center', justifyContent:'center', gap:8, padding:'14px 16px', borderRight:i<TRUST.length-1?'1px solid #f0f0f0':'none', whiteSpace:'nowrap' }}>
                <span style={{ fontSize:16 }}>{t.icon}</span>
                <span style={{ fontSize:12, fontWeight:700, color:'#374151' }}>{t.label}</span>
              </div>
            ))}
          </div>
        </W>
      </div>

      {/* ══ 3. MENU SECTIONS ══ */}
      <W style={{ paddingTop:64, paddingBottom:0 }}>
        <SectionHead tag="Our Menu" title="Something Fresh for Everyone" sub="From cold- juices to grilled sandwiches — every item made fresh to order, delivered in 2 hours." />
        {loadingProds ? <Skeleton h={200} cols={4} /> : (
          <div className="hp-sec-grid">
            {sections.map(sec => {
              const st = secStyle(sec.key);
              return (
                <div key={sec.key} onClick={() => navigate(`/products?section=${sec.key}`)}
                  style={{ background:'#fff', borderRadius:18, border:`1.5px solid ${st.color}20`, overflow:'hidden', cursor:'pointer', transition:'transform 0.22s, box-shadow 0.22s, border-color 0.22s', boxShadow:'0 2px 10px rgba(0,0,0,0.05)' }}
                  onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow=`0 12px 32px ${st.color}22`; e.currentTarget.style.borderColor=`${st.color}50`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 2px 10px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor=`${st.color}20`; }}>
                  <div style={{ height:4, background:`linear-gradient(90deg,${st.color},${st.accent})` }} />
                  <div style={{ padding:'18px 18px 20px' }}>
                    <div style={{ width:48, height:48, borderRadius:13, background:st.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, marginBottom:12 }}>{sec.emoji}</div>
                    <h3 style={{ fontSize:16, fontWeight:900, color:'#111827', margin:'0 0 3px' }}>{sec.label}</h3>
                    <p style={{ fontSize:11.5, color:'#9ca3af', margin:'0 0 12px' }}>{sec.totalCount} items available</p>
                    <div style={{ display:'flex', gap:5, flexWrap:'wrap', marginBottom:14 }}>
                      {sec.categories.slice(0,3).map(cat => (
                        <span key={cat.key} style={{ fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:100, background:st.bg, color:st.color, border:`1px solid ${st.color}22` }}>
                          {cat.emoji} {cat.label}
                        </span>
                      ))}
                      {sec.categories.length > 3 && (
                        <span style={{ fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:100, background:'#f3f4f6', color:'#9ca3af' }}>+{sec.categories.length-3}</span>
                      )}
                    </div>
                    <div style={{ fontSize:12, fontWeight:700, color:st.color }}>Explore {sec.label} →</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </W>

      {/* ══ 4. BESTSELLERS ══ */}
      <W style={{ paddingTop:64 }}>
        <div className="hp-section-hdr">
          <div>
            <Tag>Bestsellers</Tag>
            <h2 className="hp-h2">Our Most Loved Picks</h2>
            <p style={{ fontSize:14, color:'#9ca3af', margin:0 }}>Ordered again and again by our regulars</p>
          </div>
          <button className="hp-btn-outline" onClick={() => navigate('/products?bestseller=true')}>View all →</button>
        </div>
        {loadingProds ? <Skeleton h={280} cols={4} /> : bestsellers.length > 0 && (
          <div className="hp-prod-grid">{bestsellers.map(p => <ProductCard key={p._id} product={p} />)}</div>
        )}
      </W>

      {/* ══ 5. CAROUSEL ══ */}
      <W style={{ paddingTop:64 }}>
        <div className="hp-section-hdr">
          <div>
            <Tag>Fresh Picks</Tag>
            <h2 className="hp-h2">Straight from Our Kitchen</h2>
            <p style={{ fontSize:14, color:'#9ca3af', margin:0 }}>Crafted fresh daily — explore each collection</p>
          </div>
          <button className="hp-btn-outline" onClick={() => navigate(SLIDES[slideIdx].nav)}>Explore →</button>
        </div>
        <div className="hp-car" style={{ position:'relative', borderRadius:22, overflow:'hidden', cursor:'pointer' }}
          onClick={() => navigate(SLIDES[slideIdx].nav)}>
          {SLIDES.map((s,i) => (
            <div key={s.key} style={{ position:'absolute', inset:0, opacity:i===slideIdx?1:0, transition:'opacity 0.65s ease', pointerEvents:i===slideIdx?'auto':'none' }}>
              <img src={s.image} alt={s.label} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
              <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top,rgba(0,0,0,0.82) 0%,rgba(0,0,0,0.2) 55%,transparent 100%)' }} />
              <div style={{ position:'absolute', bottom:0, left:0, right:0, padding:'clamp(14px,3vw,30px) clamp(16px,4vw,36px)' }}>
                <span style={{ display:'inline-block', fontSize:11, fontWeight:700, background:'rgba(255,255,255,0.14)', color:'#fff', border:'1px solid rgba(255,255,255,0.28)', padding:'3px 12px', borderRadius:100, backdropFilter:'blur(8px)', marginBottom:8 }}>{s.pet}</span>
                <h3 style={{ fontSize:'clamp(20px,4vw,40px)', fontWeight:900, color:'#fff', margin:'0 0 6px', letterSpacing:'-0.5px', lineHeight:1.1 }}>{s.label}</h3>
                <p className="hp-car-sub" style={{ fontSize:14, color:'rgba(255,255,255,0.75)', margin:'0 0 16px', maxWidth:480, lineHeight:1.6 }}>{s.sub}</p>
                <button onClick={e => { e.stopPropagation(); navigate(s.nav); }}
                  style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'10px 22px', borderRadius:100, border:'none', background:s.color, color:'#fff', fontSize:13, fontWeight:800, cursor:'pointer', boxShadow:`0 4px 20px ${s.color}55`, transition:'transform 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
                  onMouseLeave={e => e.currentTarget.style.transform='none'}>
                  Shop {s.label} →
                </button>
              </div>
            </div>
          ))}
          {/* prev / next */}
          {[{dir:-1,side:'left',sym:'‹'},{dir:1,side:'right',sym:'›'}].map(({dir,side,sym}) => (
            <button key={side} onClick={e => { e.stopPropagation(); goSlide(slideIdx+dir); }}
              style={{ position:'absolute', top:'50%', [side]:14, transform:'translateY(-50%)', width:40, height:40, borderRadius:'50%', border:'1px solid rgba(255,255,255,0.3)', background:'rgba(255,255,255,0.12)', color:'#fff', fontSize:22, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(8px)', zIndex:10, transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.28)'}
              onMouseLeave={e => e.currentTarget.style.background='rgba(255,255,255,0.12)'}>
              {sym}
            </button>
          ))}
          {/* dots */}
          <div style={{ position:'absolute', bottom:16, left:'50%', transform:'translateX(-50%)', display:'flex', gap:6, zIndex:10 }}>
            {SLIDES.map((_,i) => (
              <button key={i} onClick={e => { e.stopPropagation(); goSlide(i); }}
                style={{ width:i===slideIdx?22:7, height:7, borderRadius:100, border:'none', background:i===slideIdx?'#fff':'rgba(255,255,255,0.4)', cursor:'pointer', padding:0, transition:'all 0.3s' }} />
            ))}
          </div>
        </div>
        {/* thumbnails */}
        <div style={{ display:'flex', gap:8, marginTop:10 }}>
          {SLIDES.map((s,i) => (
            <div key={s.key} onClick={() => goSlide(i)}
              style={{ flex:'1 1 0', minWidth:0, position:'relative', borderRadius:12, overflow:'hidden', height:60, cursor:'pointer', outline:`2.5px solid ${i===slideIdx?s.color:'transparent'}`, outlineOffset:'-2.5px', transition:'outline-color 0.2s' }}>
              <img src={s.image} alt={s.label} style={{ width:'100%', height:'100%', objectFit:'cover', filter:i===slideIdx?'brightness(1)':'brightness(0.58)', transition:'filter 0.2s' }} />
              <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top,rgba(0,0,0,0.5) 0%,transparent 60%)' }} />
              <span style={{ position:'absolute', bottom:4, left:0, right:0, textAlign:'center', fontSize:9, fontWeight:800, color:'#fff' }}>{s.label}</span>
            </div>
          ))}
        </div>
      </W>

      {/* ══ 6. HOW IT WORKS ══ */}
      <div style={{ background:'linear-gradient(135deg,#0a3d1f,#0f5230)', marginTop:64 }}>
        <W style={{ paddingTop:60, paddingBottom:60 }}>
          <SectionHead tag="The Process" title="From Our Kitchen to Your Door" sub="Every order goes through the same careful process — freshly made, freshly delivered." />
          <div className="hp-how-grid">
            {HOW.map((step,i) => (
              <div key={step.n} style={{ padding:'28px 24px', background:'rgba(255,255,255,0.04)', borderRadius:0, borderRight:i<HOW.length-1?'1px solid rgba(255,255,255,0.08)':'none' }}>
                <div style={{ fontSize:10, fontWeight:900, color:'rgba(255,255,255,0.22)', letterSpacing:'2px', marginBottom:14 }}>{step.n}</div>
                <div style={{ fontSize:30, marginBottom:12 }}>{step.icon}</div>
                <h3 style={{ fontSize:16, fontWeight:800, color:'#fff', margin:'0 0 8px' }}>{step.title}</h3>
                <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:0 }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </W>
      </div>

      {/* ══ 7. FEATURED ══ */}
      {featured.length > 0 && (
        <W style={{ paddingTop:64 }}>
          <div className="hp-section-hdr">
            <div>
              <Tag color="#d97706">Chef&apos;s Picks</Tag>
              <h2 className="hp-h2">Signature Specials</h2>
              <p style={{ fontSize:14, color:'#9ca3af', margin:0 }}>Our most unique creations — you won&apos;t find these anywhere else</p>
            </div>
            <button className="hp-btn-outline hp-btn-amber" onClick={() => navigate('/products?featured=true')}>View all →</button>
          </div>
          <div className="hp-prod-grid">{featured.map(p => <ProductCard key={p._id} product={p} />)}</div>
        </W>
      )}

      {/* ══ 8. STATS ══ */}
      <W style={{ paddingTop:64 }}>
        <div style={{ background:'#fff', borderRadius:22, border:'1px solid #f0f0f0', boxShadow:'0 4px 24px rgba(0,0,0,0.06)', padding:'36px 28px' }}>
          <div className="hp-stats-grid">
            {STATS.map(s => (
              <div key={s.label} style={{ textAlign:'center', padding:'8px 0' }}>
                <div style={{ fontSize:22, marginBottom:6 }}>{s.icon}</div>
                <div style={{ fontSize:26, fontWeight:900, color:'#0f172a', letterSpacing:'-0.5px', lineHeight:1 }}>{s.value}</div>
                <div style={{ fontSize:11, color:'#9ca3af', fontWeight:600, marginTop:5, textTransform:'uppercase', letterSpacing:'0.5px' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </W>

      {/* ══ 9. WHY US ══ */}
      <W style={{ paddingTop:64 }}>
        <SectionHead tag="Why ProteinSpot" title="We&apos;re Different Because We Care" sub="Every decision we make is about getting you the freshest, cleanest, most natural food possible." />
        <div className="hp-why-grid">
          {WHY.map(w => (
            <div key={w.title} style={{ background:'#fff', borderRadius:16, padding:'22px 20px', border:'1px solid #f0f0f0', boxShadow:'0 2px 8px rgba(0,0,0,0.04)', display:'flex', gap:16, alignItems:'flex-start', transition:'transform 0.2s, box-shadow 0.2s, border-color 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow=`0 12px 28px ${w.color}18`; e.currentTarget.style.borderColor=`${w.color}30`; }}
              onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.04)'; e.currentTarget.style.borderColor='#f0f0f0'; }}>
              <div style={{ width:46, height:46, borderRadius:13, background:`${w.color}12`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:21, flexShrink:0, border:`1.5px solid ${w.color}20` }}>{w.icon}</div>
              <div>
                <h3 style={{ fontSize:14, fontWeight:800, color:'#111827', margin:'0 0 6px' }}>{w.title}</h3>
                <p style={{ fontSize:13, color:'#6b7280', lineHeight:1.7, margin:0 }}>{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </W>

      {/* ══ 10. TESTIMONIALS ══ */}
      <div style={{ background:'linear-gradient(135deg,#f0fdf4,#dcfce7,#f0fdf4)', marginTop:64 }}>
        <W style={{ paddingTop:60, paddingBottom:60 }}>
          <SectionHead tag="Reviews" title="What Our Customers Say" sub="Here's what Bengaluru thinks about waking up to ProteinSpot every morning." />
          {/* featured */}
          <div style={{ background:'#fff', borderRadius:22, padding:'clamp(20px,4vw,36px) clamp(20px,4vw,40px)', boxShadow:'0 8px 36px rgba(45,139,78,0.1)', border:'1px solid rgba(45,139,78,0.12)', marginBottom:12, position:'relative' }}>
            <div style={{ display:'flex', gap:4, marginBottom:12 }}>
              {'★★★★★'.split('').map((_,i) => <span key={i} style={{ color:'#f59e0b', fontSize:17 }}>★</span>)}
            </div>
            <p style={{ fontSize:'clamp(14px,2vw,17px)', color:'#374151', lineHeight:1.75, margin:'0 0 20px', fontStyle:'italic' }}>
              &quot;{TESTIMONIALS[activeReview].text}&quot;
            </p>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:42, height:42, borderRadius:'50%', background:'linear-gradient(135deg,#2D8B4E,#4CAF72)', color:'#fff', fontSize:13, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{TESTIMONIALS[activeReview].avatar}</div>
                <div>
                  <div style={{ fontSize:13, fontWeight:800, color:'#111827' }}>{TESTIMONIALS[activeReview].name}</div>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>{TESTIMONIALS[activeReview].location} · {TESTIMONIALS[activeReview].orders}</div>
                </div>
              </div>
              <div style={{ display:'flex', gap:6 }}>
                {TESTIMONIALS.map((_,i) => (
                  <button key={i} onClick={() => { setActiveReview(i); clearInterval(reviewTimer.current); }}
                    style={{ width:i===activeReview?20:7, height:7, borderRadius:100, border:'none', cursor:'pointer', background:i===activeReview?'#2D8B4E':'#d1d5db', padding:0, transition:'all 0.3s' }} />
                ))}
              </div>
            </div>
          </div>
          {/* grid */}
          <div className="hp-rev-grid">
            {TESTIMONIALS.filter((_,i) => i!==activeReview).slice(0,3).map((t,i) => (
              <div key={i} style={{ background:'#fff', borderRadius:16, padding:'18px', border:'1px solid rgba(45,139,78,0.1)', cursor:'pointer' }}
                onClick={() => { setActiveReview(TESTIMONIALS.indexOf(t)); clearInterval(reviewTimer.current); }}>
                <div style={{ display:'flex', gap:2, marginBottom:8 }}>
                  {'★★★★★'.split('').map((_,j) => <span key={j} style={{ color:'#f59e0b', fontSize:12 }}>★</span>)}
                </div>
                <p style={{ fontSize:12.5, color:'#6b7280', lineHeight:1.65, margin:'0 0 12px', fontStyle:'italic' }}>&quot;{t.text.slice(0,90)}…&quot;</p>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                  <div style={{ width:30, height:30, borderRadius:'50%', background:'linear-gradient(135deg,#2D8B4E,#4CAF72)', color:'#fff', fontSize:10, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{t.avatar}</div>
                  <div>
                    <div style={{ fontSize:12, fontWeight:700, color:'#111827' }}>{t.name}</div>
                    <div style={{ fontSize:10, color:'#9ca3af' }}>{t.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </W>
      </div>

      {/* ══ 11. DELIVERY INFO ══ */}
      <W style={{ paddingTop:64 }}>
        <div className="hp-del-grid">
          {[
            { icon:'🚚', title:'2-Hour Delivery',    desc:'We deliver across Hebbal, Bengaluru within 2 hours of placing your order.',     color:'#2196F3' },
            { icon:'🎁', title:'Free on ₹299+',      desc:'Orders above ₹299 get free delivery — no hidden charges, no surprises.', color:'#2D8B4E' },
            { icon:'🔄', title:'Easy Cancellation',  desc:'Cancel any order before preparation begins — quick and hassle-free.',    color:'#d97706' },
            { icon:'💬', title:'Live Support',        desc:'Chat with us on WhatsApp or call us anytime during delivery hours.',     color:'#9C27B0' },
          ].map(d => (
            <div key={d.title} style={{ background:'#fff', borderRadius:16, padding:'20px 18px', border:'1px solid #f0f0f0', boxShadow:'0 2px 8px rgba(0,0,0,0.04)', display:'flex', gap:14, alignItems:'flex-start' }}>
              <div style={{ width:42, height:42, borderRadius:12, background:`${d.color}12`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:19, flexShrink:0 }}>{d.icon}</div>
              <div>
                <h3 style={{ fontSize:13.5, fontWeight:800, color:'#111827', margin:'0 0 4px' }}>{d.title}</h3>
                <p style={{ fontSize:12, color:'#6b7280', lineHeight:1.6, margin:0 }}>{d.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </W>

      {/* ══ 12. FINAL CTA ══ */}
      <W style={{ paddingTop:64, paddingBottom:64 }}>
        <div style={{ background:'linear-gradient(135deg,#062c1b 0%,#0a3d1f 50%,#1a7040 100%)', borderRadius:24, padding:'clamp(32px,5vw,60px) clamp(20px,4vw,40px)', textAlign:'center', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:-60, right:-60, width:260, height:260, borderRadius:'50%', background:'rgba(76,175,114,0.08)', pointerEvents:'none' }} />
          <div style={{ position:'absolute', bottom:-40, left:-40, width:200, height:200, borderRadius:'50%', background:'rgba(255,179,71,0.06)', pointerEvents:'none' }} />
          <div style={{ position:'relative', zIndex:2 }}>
            <div style={{ fontSize:40, marginBottom:14 }}>🥤</div>
            <h2 style={{ color:'#fff', fontWeight:900, fontSize:'clamp(22px,4vw,36px)', margin:'0 0 12px', letterSpacing:'-0.5px' }}>Ready to Go Healthy?</h2>
            <p style={{ color:'rgba(255,255,255,0.7)', fontSize:15, margin:'0 auto 28px', maxWidth:460, lineHeight:1.7 }}>
              Join 500+ customers in Hebbal, Bengaluru who start their day with ProteinSpot. Fresh juices, salads and smoothies — delivered in 2 hours.
            </p>
            <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap', marginBottom:16 }}>
              <button onClick={() => navigate('/products')} className="hp-btn-primary hp-btn-lg">Order Now →</button>
              <button onClick={() => navigate('/contact')} className="hp-btn-ghost">Contact Us</button>
            </div>
            <p style={{ color:'rgba(255,255,255,0.4)', fontSize:11 }}>Free delivery on orders above ₹299 · Currently serving Hebbal, Bengaluru</p>
          </div>
        </div>
      </W>

      <Footer />

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.45} }
        @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.3}  }

        /* ── shared button styles ── */
        .hp-btn-primary {
          padding: 11px 26px; border-radius: 100px; border: none; cursor: pointer;
          background: linear-gradient(135deg,#2D8B4E,#4CAF72); color:#fff;
          font-size:15px; font-weight:800; font-family:inherit;
          box-shadow:0 6px 24px rgba(45,139,78,0.38); transition:transform 0.2s,box-shadow 0.2s;
        }
        .hp-btn-primary:hover { transform:translateY(-2px); box-shadow:0 10px 32px rgba(45,139,78,0.5); }
        .hp-btn-primary.hp-btn-lg { padding:14px 36px; font-size:16px; }
        .hp-btn-ghost {
          padding:11px 22px; border-radius:100px; border:1.5px solid rgba(255,255,255,0.38);
          cursor:pointer; background:rgba(255,255,255,0.08); color:#fff;
          font-size:15px; font-weight:700; font-family:inherit; transition:background 0.2s;
        }
        .hp-btn-ghost:hover { background:rgba(255,255,255,0.16); }
        .hp-btn-outline {
          padding:9px 22px; border-radius:100px; border:2px solid rgba(45,139,78,0.3);
          background:rgba(45,139,78,0.05); color:#2D8B4E;
          font-size:13px; font-weight:700; cursor:pointer; font-family:inherit;
          white-space:nowrap; transition:background 0.2s; flex-shrink:0;
        }
        .hp-btn-outline:hover { background:rgba(45,139,78,0.12); }
        .hp-btn-amber { border-color:rgba(217,119,6,0.3)!important; background:rgba(217,119,6,0.05)!important; color:#d97706!important; }
        .hp-btn-amber:hover { background:rgba(217,119,6,0.12)!important; }

        /* ── section header row ── */
        .hp-section-hdr {
          display:flex; align-items:flex-end; justify-content:space-between;
          margin-bottom:28px; flex-wrap:wrap; gap:12px;
        }
        .hp-h2 { font-size:clamp(20px,3vw,30px); font-weight:900; color:#0f172a; margin:0 0 5px; letter-spacing:-0.5px; }

        /* ── hero ── */
        .hp-hero {
          display:grid; grid-template-columns:1.1fr 0.9fr;
          gap:40px; align-items:center;
        }
        .hp-hero-right { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
        .hp-stats-row  { display:flex; gap:24px; flex-wrap:wrap; }

        /* ── section cards ── */
        .hp-sec-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(200px,1fr)); gap:14px; }

        /* ── product grid ── */
        .hp-prod-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:12px; }

        /* ── carousel ── */
        .hp-car { height:400px; }

        /* ── how it works ── */
        .hp-how-grid {
          display:grid; grid-template-columns:repeat(4,1fr);
          background:rgba(255,255,255,0.06); border-radius:18px;
          overflow:hidden; border:1px solid rgba(255,255,255,0.08);
        }

        /* ── stats ── */
        .hp-stats-grid { display:grid; grid-template-columns:repeat(6,1fr); gap:16px; }

        /* ── why us ── */
        .hp-why-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:14px; }

        /* ── reviews ── */
        .hp-rev-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:10px; }

        /* ── delivery ── */
        .hp-del-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:14px; }

        /* ── TABLET (640–1023px) ── */
        @media(min-width:640px) {
          .hp-prod-grid { grid-template-columns:repeat(3,1fr); gap:14px; }
        }
        @media(min-width:1024px) {
          .hp-prod-grid { grid-template-columns:repeat(4,1fr); gap:16px; }
          .hp-stats-grid { grid-template-columns:repeat(6,1fr); }
        }

        /* ── MOBILE (≤767px) ── */
        @media(max-width:767px) {
          .hp-hero       { grid-template-columns:1fr; gap:20px; }
          .hp-hero-right { grid-template-columns:1fr 1fr; gap:10px; }
          .hp-how-grid   { grid-template-columns:1fr 1fr; }
          .hp-car        { height:260px!important; }
          .hp-car-sub    { display:none; }
          .hp-stats-grid { grid-template-columns:repeat(3,1fr); gap:12px; }
          .hp-stats-row  { gap:16px; }
        }

        /* ── SMALL MOBILE (≤479px) ── */
        @media(max-width:479px) {
          .hp-hero-right { grid-template-columns:1fr 1fr; gap:8px; }
          .hp-how-grid   { grid-template-columns:1fr; }
          .hp-prod-grid  { grid-template-columns:repeat(2,1fr)!important; gap:10px!important; }
          .hp-stats-grid { grid-template-columns:repeat(2,1fr); }
          .hp-sec-grid   { grid-template-columns:1fr 1fr; }
          .hp-car        { height:220px!important; }
          .hp-why-grid   { grid-template-columns:1fr; }
          .hp-del-grid   { grid-template-columns:1fr; }
          .hp-rev-grid   { grid-template-columns:1fr; }
          .hp-section-hdr { flex-direction:column; align-items:flex-start; }
        }
      `}</style>
    </div>
  );
}